import ModuleSetting from "../models/ModuleSetting";
import useStaticData from "./useStaticData";

export default function useModuleSettingProduct(
	moduleSetting: Pick<ModuleSetting, "category" | "productVariantId">
) {
	const { products } = useStaticData();

	const product = products.find((p) => p.id === moduleSetting.category);
	if (!product) {
		throw new Error(`Product with id ${moduleSetting.category} not found`);
	}

	const variant = product.variants.find(
		(v) => v.id === moduleSetting.productVariantId
	);
	if (!variant) {
		throw new Error(
			`Variant ${moduleSetting.productVariantId} does not exist on product Product with id ${moduleSetting.category}`
		);
	}

	return { product, variant };
}
